import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-lg max-w-none text-gray-700" data-id="element-13">
      <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-14">
        Política de Privacidad
      </h3>
      <p className="mb-4" data-id="element-15">
        <strong data-id="element-16">Última actualización:</strong>{' '}
        {new Date().toLocaleDateString('es-ES')}
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-17">
        1. Información que Recopilamos
      </h4>
      <p className="mb-4" data-id="element-18">
        Recopilamos información que usted nos proporciona directamente cuando
        realiza una compra, incluyendo:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-19">
        <li data-id="element-20">Nombre y dirección de correo electrónico</li>
        <li data-id="element-21">
          Información de pago (procesada de forma segura por nuestros
          proveedores de pago)
        </li>
        <li data-id="element-22">Dirección IP y datos del navegador</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-23">
        2. Cómo Usamos Su Información
      </h4>
      <p className="mb-4" data-id="element-24">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-25">
        <li data-id="element-26">Procesar y entregar su compra</li>
        <li data-id="element-27">Enviarle el producto digital adquirido</li>
        <li data-id="element-28">Comunicarnos con usted sobre su pedido</li>
        <li data-id="element-29">Mejorar nuestros productos y servicios</li>
        <li data-id="element-30">Cumplir con obligaciones legales</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-31">
        3. Protección de Datos
      </h4>
      <p className="mb-4" data-id="element-32">
        Implementamos medidas de seguridad técnicas y organizativas apropiadas
        para proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-33">
        4. Compartir Información
      </h4>
      <p className="mb-4" data-id="element-34">
        No vendemos, intercambiamos ni transferimos su información personal a
        terceros, excepto:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-35">
        <li data-id="element-36">
          Proveedores de servicios de pago necesarios para procesar
          transacciones
        </li>
        <li data-id="element-37">Cuando sea requerido por ley</li>
        <li data-id="element-38">Para proteger nuestros derechos legales</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-39">
        5. Sus Derechos
      </h4>
      <p className="mb-4" data-id="element-40">Usted tiene derecho a:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-41">
        <li data-id="element-42">Acceder a su información personal</li>
        <li data-id="element-43">Solicitar la corrección de datos inexactos</li>
        <li data-id="element-44">Solicitar la eliminación de sus datos</li>
        <li data-id="element-45">Oponerse al procesamiento de sus datos</li>
        <li data-id="element-46">Retirar su consentimiento en cualquier momento</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-47">
        6. Cookies
      </h4>
      <p className="mb-4" data-id="element-48">
        Utilizamos cookies y tecnologías similares para mejorar su experiencia
        en nuestro sitio web, analizar el tráfico y personalizar el contenido.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-49">
        7. Cambios a Esta Política
      </h4>
      <p className="mb-4" data-id="element-50">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios entrarán en vigor inmediatamente después
        de su publicación en esta página.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-51">
        8. Contacto
      </h4>
      <p className="mb-4" data-id="element-52">
        Si tiene preguntas sobre esta política de privacidad, puede contactarnos
        a través de los canales proporcionados en nuestro sitio web.
      </p>
    </div>;
}